import { FC, useEffect } from 'react';
import classNames from 'classnames';
import { useApplicationContext } from 'components/hooks/UseApplicationContext';
import { consentUpdateQumuAction } from 'store/Consent/consentAction';
import { useAppDispatch } from 'store/store';
import { useGetMode } from './SelectedModeService';

export interface JSXElementProps {
    [key: string]: any;
}

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-mini-footer': JSXElementProps;
                'sgwt-splash-screen': any;
            }
        }
    }
}

interface CookiesConsentElement {
    getUserConsentOnQumu: () => Promise<boolean>;
}

interface SplashScreenElement {
    show: () => void;
}

interface FooterProps {
    withoutBackground?: boolean;
}

export const Footer: FC<FooterProps> = ({ withoutBackground = false }) => {
    const dispatch = useAppDispatch();
    const { hasOnlyB2b2cAccess } = useApplicationContext();

    useEffect(() => {
        const updateConsent = () => {
            const widget:
                | (Element & CookiesConsentElement)
                | null = document.querySelector('sgwt-mini-footer');
            widget
                ?.getUserConsentOnQumu()
                .then((consent: boolean) =>
                    dispatch(consentUpdateQumuAction(consent)),
                );
        };

        document.addEventListener(
            'sgwt-mini-footer--current-user-consent',
            updateConsent,
        );
        document.addEventListener(
            'sgwt-mini-footer--user-consent-changed',
            updateConsent,
        );
        return () => {
            document.removeEventListener(
                'sgwt-mini-footer--current-user-consent',
                updateConsent,
            );
            document.removeEventListener(
                'sgwt-mini-footer--user-consent-changed',
                updateConsent,
            );
        };
    }, [dispatch]);

    useEffect(() => {
        const widget:
            | (Element & SplashScreenElement)
            | null = document.querySelector('sgwt-splash-screen');
        if (typeof widget?.show !== 'function') {
            const onReady = () => widget?.show();
            widget?.addEventListener('sgwt-splash-screen--ready', onReady);
            return () => widget?.removeEventListener('sgwt-splash-screen--ready', onReady);
        } else {
            widget?.show();
        }
    }, []);

    const mode = useGetMode();
    const application = hasOnlyB2b2cAccess
        ? 'service-board-b2b2c'
        : 'service-board';
    const noBorder = withoutBackground ? false : true;
    const miniFooterProps: JSXElementProps = {
        'id': 'sgwt-mini-footer',
        'mode': mode,
        'accessibility-compliance': 'partial',
        'accessibility-link': '/accessibility-statement.html',
    };
    if (hasOnlyB2b2cAccess) {
        miniFooterProps['contact-us'] = '{"link":"https://sharinbox.sgmarkets.com/nousContacter"}';
    }
    else {
        miniFooterProps['contact-us-by-help-center'] = 'sgwt-help-center';
    }
    return <div className={classNames('w-100', { 'bg-lvl2': withoutBackground })}>
        <sgwt-mini-footer
            {...miniFooterProps}
        />
        <sgwt-splash-screen
            id="sgwt-splash-screen"
            application={application}
            sg-connect-support="sg-connect-v2"
            no-border={noBorder}
        />
    </div>;
};
